import React from "react";
import styled from 'styled-components'
// reactstrap components
import {
  Container,
  Row
} from "reactstrap";

import IndexNavbar from "components/Navbars/IndexNavbar.js";
// import IndexHeader from "components/Headers/IndexHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import LogisticsBackground from 'assets/img/logistics123.png';
import { useTranslation } from 'react-i18next';

const MainText = styled.h3`
  text-align: justify;
`

const BackImage = styled.img`
  height: 600px;
  width: 100%;
`
function ProfilePage() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <IndexNavbar />
      <BackImage src={LogisticsBackground} alt='logistics'/>
      <Container>
      <Row>
        <MainText>
          {t('AboutUs')}
        <br />
        </MainText>
      </Row>
      <DemoFooter />
      </Container>
    </>
  );
}

export default ProfilePage;
